module.exports = __webpack_public_path__ + "img/bold.5abcc026.svg";